import * as React from 'react';
const IconArrowRight = (props) => (
  <svg
    width={24}
    height={20}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: '24px', height: '20px' }}
    {...props}
  >
    <path
      d="M11.8682 0.919922C12.8874 -0.234953 14.6148 -0.312747 15.7266 0.746094L23.1143 7.78223C23.7282 8.3669 24.024 9.17585 23.9961 9.97754C24.037 10.7939 23.7396 11.6221 23.1143 12.2178L15.7266 19.2539C14.6147 20.3128 12.8874 20.2351 11.8682 19.0801C10.8489 17.9249 10.9242 16.1302 12.0361 15.0713L14.3027 12.9121H2.73145C1.22313 12.9121 8.38579e-05 11.6423 0 10.0752C0 8.50806 1.22308 7.23828 2.73145 7.23828H14.4609L12.0361 4.92871C10.9242 3.86976 10.8489 2.07514 11.8682 0.919922Z"
      fill="#003764"
    />
  </svg>
);
export default IconArrowRight;
